<script>
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import IconZoomGlass from "@js/components/Icons/IconZoomGlass.vue";
import ProductImageLoad from "@js/components/Sections/Product/Components/ProductImageLoad.vue";

export default {
    name: "ImageSlider",
    components: {ProductImageLoad, IconZoomGlass, VueEasyLightbox, IconAngleLeft},
    props: {
        images: {
            required: true,
            type: Array,
        }
    },
    data() {
        return {
            is_preview_open: false,
            preview_key: 0,
        };
    },
    methods: {
        openPreview(preview_key) {
            this.preview_key = preview_key;
            this.is_preview_open = true;
        },
        nextSlide() {
            if (this.preview_key < this.images.length - 1) {
                this.preview_key++;
            } else {
                this.preview_key = 0; // Возвращаемся к первому слайду
            }
        },
        prevSlide() {
            if (this.preview_key > 0) {
                this.preview_key--;
            } else {
                this.preview_key = this.images.length - 1; // Переходим к последнему слайду
            }
        },
    }
}
</script>

<template>
    <div id="gallery" class="relative w-full z-1" data-carousel="static">
        <div class="relative h-56 overflow-hidden rounded-lg md:h-96 border border-gray-100 shadow">
            <div v-for="(image, key) in images" :key="key"
                 @click.prevent="openPreview(key)"
                 class="group cursor-pointer"
                 :class="{'hidden': preview_key !== key, 'block': preview_key === key}"
                 data-carousel-item>
                <ProductImageLoad :img="image" :img_key="key"/>
                <div
                    class="absolute w-full h-full bottom-0 left-0 p-4 text-white uppercase opacity-0 group-hover:opacity-100 bg-white/50 transition-all">
                    <div class="w-full h-full flex items-center justify-center">
                        <IconZoomGlass/>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" @click="prevSlide" v-if="images.length > 1"
                class="group absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none">
            <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full border-2 border-white bg-white/30 group-hover:bg-white/50 group-hover:border-indigo-600 transition">
                <IconAngleLeft class="w-4 h-4 text-gray-800"/>
            </span>
        </button>
        <button type="button" @click="nextSlide" v-if="images.length > 1"
                class="group absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none">
            <span
                class="inline-flex items-center justify-center w-10 h-10 rounded-full border-2 border-white bg-white/30 group-hover:bg-white/50 group-hover:border-indigo-600 transition">
                <IconAngleLeft class="w-4 h-4 text-gray-800 rotate-180"/>
            </span>
        </button>
    </div>
    <VueEasyLightbox :visible="is_preview_open" :imgs="images" :index="preview_key" @hide="is_preview_open = false"/>
</template>

<style scoped lang="scss">
.z-1 {
    z-index: 1;
}
</style>
